"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useDebounce(func, delay) {
    var timeoutRef = (0, react_1.useRef)(null);
    var debouncedFunc = (0, react_1.useCallback)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            func.apply(void 0, args);
        }, delay);
    }, [func, delay]);
    return debouncedFunc;
}
exports.default = useDebounce;
